import {
    Component,
    Input,
} from '@angular/core';
import { Evaluation } from '../../../../utils/evalutaion';

@Component({
    selector: 'container-wrap-options',
    template: '<ng-content></ng-content>'
})
export class ContainerWrapOptionsComponent {
    // io
    private _itemHeight: string;
    /**
     * Specifies the component's height
     */
    get itemHeight(): number | string | Function {
        return this._itemHeight;
    }
    @Input() set itemHeight(value: number | string | Function) {
        this._itemHeight = Evaluation.evaluateToStyleWidthHeight(value);
    }
    private _itemWidth: string;
    /**
     * Specifies the component's width
     */
    get itemWidth(): number | string | Function {
        return this._itemWidth;
    }
    @Input() set itemWidth(value: number | string | Function) {
        this._itemWidth = Evaluation.evaluateToStyleWidthHeight(value);
    }
    private _itemSpacing: string;
    /**
     * Specifies the component's height
     */
    get itemSpacing(): number | string | Function {
        return this._itemSpacing;
    }
    @Input() set itemSpacing(value: number | string | Function) {
        this._itemSpacing = Evaluation.evaluateToStyleWidthHeight(value);
    }
}



// WEBPACK FOOTER //
// ./client-src/app/core/components/container/nested/options/container-wrap.option.ts